import { makeStyles, shorthands } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useAdminPaginationFooterStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    ...shorthands.borderTop("1px", "solid", designTokens.neutral[100]),
    backgroundColor: designTokens.neutral[50],
    fontFamily: designTokens.fontFamily,
  },

  paginatorWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: designTokens.spacing[3],
  },

  infoText: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[500],
  },

  paginatorContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
  },

  navButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: designTokens.controlHeight.sm,
    height: designTokens.controlHeight.sm,
    minWidth: designTokens.controlHeight.sm,
    backgroundColor: "transparent",
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    borderRadius: designTokens.borderRadius.md,
    color: designTokens.neutral[500],
    cursor: "pointer",
    transition: `all ${designTokens.transition.fast}`,
    "& svg": {
      width: designTokens.iconSize.xs,
      height: designTokens.iconSize.xs,
    },
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.neutral[700],
    },
    ":disabled": {
      opacity: 0.4,
      cursor: "not-allowed",
      backgroundColor: "transparent",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },

  pageButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: designTokens.controlHeight.sm,
    height: designTokens.controlHeight.sm,
    minWidth: designTokens.controlHeight.sm,
    backgroundColor: "transparent",
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    borderRadius: designTokens.borderRadius.md,
    color: designTokens.neutral[600],
    cursor: "pointer",
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
    transition: `all ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },

  pageButtonActive: {
    backgroundColor: designTokens.accent[500],
    ...shorthands.border("1px", "solid", designTokens.accent[500]),
    color: designTokens.neutral.white,
    fontWeight: designTokens.fontWeight.semibold,
    ":hover": {
      backgroundColor: designTokens.accent[600],
    },
  },
});
